import {peoplePropertiesClient} from 'common/report/queries/query-api/people-properties-client';

import type {ProcessedArbProperty} from '../queries/query-api/utils';
import {Store} from './store';

export const peoplePropertiesStore = new Store<ProcessedArbProperty[]>({
  apiClient: peoplePropertiesClient,
  defaultValue: [],
  name: `people-properties`,
});
